import { ItemProperties } from '../../../types';
import { useRootSelector } from '../../../store';

import { useFilteredProductQuery } from '../../api/useFilteredProduct';

import { selectProductTag } from '../../item/store/itemSlice';

import { SharedPreviewComponent } from './SharedPreview';

interface ProductPreviewProps {
  mobile?: boolean;
  productTag?: string;
  itemPropertiesOverride?: ItemProperties;
  domIdOverride?: string;
}

export function ProductPreviewComponent({
  mobile,
  productTag,
  itemPropertiesOverride,
  domIdOverride
}: ProductPreviewProps) {
  const shopifyProductTag: string =
    useRootSelector(selectProductTag) || productTag || '';
  const { data: product } = useFilteredProductQuery(shopifyProductTag);

  return (
    <SharedPreviewComponent
      product={product}
      mobile={mobile}
      itemPropertiesOverride={itemPropertiesOverride}
      domIdOverride={domIdOverride}
    />
  );
}
